<fullscreen-page>
  <content-column look="dark" helpSwitch="true">
    <div slot="content" class="d-flex flex-column h-100 p-2 overflow-auto">
      <np-stepper [name]="selectedItem" [steps]="stages" (onStepChange)="selectStage($event)"></np-stepper>
      <div class="flex-grow-1">
        <router-outlet></router-outlet>
      </div>
    </div>
  </content-column>
</fullscreen-page>
